import React from 'react';
import './TimeMachine.css';
import { ERAS, useEra } from '../context/EraContext';

const TimeMachine = ({ compact = false }) => {
  const { isOn, setIsOn, index, setIndex, era } = useEra();
  // A hidden era (reached by an easter egg) isn't a dial stop, but the readout
  // should still name where you are.
  const active = (isOn && era) || ERAS[index];

  // Wraps around — the dial has no "start" or "end", just a full turn.
  const step = (delta) => setIndex((index + delta + ERAS.length) % ERAS.length);

  // Phone-sized panel for the mobile menu: the same breaker switch and crank,
  // minus the 320px dial that can't fit on a narrow navbar.
  if (compact) {
    return (
      <div className="tmach tmach-compact">
        <button
          type="button"
          className={isOn ? 'tmach-toggle is-on' : 'tmach-toggle'}
          onClick={() => setIsOn(v => !v)}
          aria-pressed={isOn}
        >
          <span className="tmach-toggle-label">TIME<br />MACHINE</span>
          <span className="tmach-toggle-switch">
            <span className="tmach-toggle-knob" />
          </span>
          <span className="tmach-toggle-state">{isOn ? 'ON' : 'OFF'}</span>
        </button>
        {isOn && (
          <div className="tmach-compact-dial">
            <button type="button" className="tm-nudge" onClick={() => step(-1)} aria-label="Previous era">‹</button>
            <div className="tm-readout" aria-live="polite">
              <span className="tm-readout-text" style={{ color: active.color }}>{active.label}</span>
            </div>
            <button type="button" className="tm-nudge" onClick={() => step(1)} aria-label="Next era">›</button>
          </div>
        )}
      </div>
    );
  }

  return (
    <div className="tmach">
      <button
        type="button"
        className={isOn ? 'tmach-toggle is-on' : 'tmach-toggle'}
        onClick={() => setIsOn(v => !v)}
        aria-pressed={isOn}
      >
        <span className="tmach-toggle-label">TIME<br />MACHINE</span>
        <span className="tmach-toggle-switch">
          <span className="tmach-toggle-knob" />
        </span>
        <span className="tmach-toggle-state">{isOn ? 'ON' : 'OFF'}</span>
      </button>

      <div className={isOn ? 'tmach-reveal is-open' : 'tmach-reveal'}>
        <div className="tmach-reveal-inner">
          <div className="tm-readout" aria-hidden="true">
            <span className="tm-readout-text" style={{ color: active.color }}>{active.label}</span>
          </div>

          <button type="button" className="tm-nudge" onClick={() => step(-1)} aria-label="Previous era">‹</button>

          <div
            className="tm-track"
            role="radiogroup"
            aria-label="Era do site"
            style={{ '--pos': index, '--era-color': active.color, '--stops': ERAS.length }}
          >
            <div className="tm-needle" />
            {ERAS.map((era, i) => (
              <label className="tm-stop" key={era.year}>
                <input
                  type="radio"
                  name="tm-era"
                  value={era.year}
                  checked={index === i}
                  onChange={() => setIndex(i)}
                />
                <span className="tm-dot" />
              </label>
            ))}
          </div>

          <button type="button" className="tm-nudge" onClick={() => step(1)} aria-label="Next era">›</button>
        </div>
      </div>
    </div>
  );
};

export default TimeMachine;
